import { AuthBaseURL } from '../constants/global';
import APIService from './api';
import AuthService from './auth';
import CookieManager from './cookies';
import UserService from './user';
import AxiosClient from './api/client';

class AuthApiService extends AxiosClient {
  constructor(baseURL: string) {
    super({
      HTTPClientParams: { baseURL },
      isProtected: true,
    });
  }

  public async request(props: any): Promise<any> {
    return this.instance.request(props);
  }
}

const authApiService = new AuthApiService(AuthBaseURL ?? '');

const apiService = new APIService();

export { apiService, AuthService, CookieManager, UserService, authApiService };
